var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicUrls({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.624 10.572a.586.586 0 0 0 0 .847c.998.971.998 2.55 0 3.521l-5.238 5.1a2.609 2.609 0 0 1-3.617 0l-.788-.767a2.446 2.446 0 0 1 0-3.521l5.238-5.1a.586.586 0 0 0 0-.847.625.625 0 0 0-.87 0l-5.238 5.1a3.619 3.619 0 0 0 0 5.215l.788.767a3.829 3.829 0 0 0 2.679 1.078c.97 0 1.94-.36 2.678-1.078l5.238-5.1a3.625 3.625 0 0 0 0-5.215.625.625 0 0 0-.87 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.884 3.871l-.788-.767c-1.476-1.437-3.88-1.437-5.356 0l-5.239 5.1a3.625 3.625 0 0 0 0 5.215.625.625 0 0 0 .87 0 .586.586 0 0 0 0-.847 2.446 2.446 0 0 1 0-3.521l5.239-5.1a2.609 2.609 0 0 1 3.616 0l.788.767c.998.972.998 2.55 0 3.521l-5.238 5.1a.586.586 0 0 0 0 .847.627.627 0 0 0 .433.178.608.608 0 0 0 .432-.178l5.239-5.1a3.619 3.619 0 0 0 .004-5.215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicUrls);
export default __webpack_public_path__ + "static/media/public-urls.e4575261a1ae3a13727e0df8fe6ee470.svg";
export { ForwardRef as ReactComponent };